export const SET_MESSAGES = 'setMessages'
export const APPEND_MESSAGE = 'appendMessage'
export const UPDATE_MESSAGE = 'updateMessage'
export const SET_SENDING_STATUS = 'setSendingStatus'
export const SET_MASS_SENDING_STATUS = 'setMassSendingStatus'
export const SET_UPLOADING_FILE = 'setUploadingFile'
